import { createBaseHttpClient } from '@/http/base-client'
import { AxiosError } from 'axios'
import Swal from 'sweetalert2'

const customerClient = createBaseHttpClient()

const excludeForceLogoutPath = [
  '/customer/login',
  '/customer/forgot-password',
  '/customer/reset-password',
  '/customer/register',
  '/customer/logout'
]

customerClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response?.status !== 401) {
      return Promise.reject(error)
    }

    if (
      window.location.pathname.startsWith('/customer') &&
      !excludeForceLogoutPath.includes(window.location.pathname)
    ) {
      notifySessionExpired('/customer/login')
    }

    return Promise.reject(error)
  }
)

const notifySessionExpired = (path: string) => {
  void Swal.fire({
    title: 'Uw sessie is verlopen. Log opnieuw in.',
    confirmButtonText: 'OK',
    allowOutsideClick: false,
    icon: 'warning',
    confirmButtonColor: '#0ea053'
  }).then((result) => {
    if (result.isConfirmed) {
      window.location.replace(path)
      window.location.reload()
    }
  })
}

export default customerClient
